
































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/left-nav.vue";
import Pagination from "@/components/paginaiton.vue";
import HospitalDetail from "./hospital-detail.vue";
import {
  GetHospitalList,
  SaveHospital,
  GetHospitalDetail,
  DeleteHospital
} from "@/request/system";
@Component({
  components: {
    MainHeader,
    LeftNav,
    Pagination,
    HospitalDetail
  }
})
export default class SystemHospital extends Vue {
  // 搜索条件
  private filters: any = {
    search: ""
  };
  // 排序
  private cSortField: string = "创建时间";
  private cSortValue: string = "1";
  // 翻页
  private ifLoading: boolean = false;
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  // 列表
  private hospitals: any[] = [];
  // 添加机构
  private ifShowHospitalDetail: boolean = false;
  private detailType: any = "add";
  private targetHospital: any = {};
  /**
   * @description 获得用户列表
   */
  private getHospitals() {
    const params: any = {
      机构名称: this.filters.search,
      current_page: this.currentPage,
      page_count: this.pageSize,
      sort_value: this.cSortValue
    };
    GetHospitalList(this, params).then((data: any) => {
      this.hospitals = data.hospitals;
      this.totalPage = data.total_page;
      this.totalCount = data.total_count;
    });
  }
  /**
   * @description 新增机构
   */
  private addHospital() {
    this.detailType = "add";
    this.targetHospital = {};
    this.ifShowHospitalDetail = true;
  }
  /**
   * @description 关闭弹窗
   */
  private hospitalDetailClose() {
    this.ifShowHospitalDetail = false;
  }
  /**
   * @description 新增用户后
   */
  private refresh() {
    this.ifShowHospitalDetail = false;
    if (this.detailType === "add") {
      this.currentPage = 1;
      this.cSortValue = "0";
      this.filters.search = "";
    }
    this.getHospitals();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.getHospitals();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.cSortField = ev["prop"];
    this.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.getHospitals();
  }
  /**
   * @description 渲染所属机构
   */
  private renderSuoshujigou(scope) {
    const arr: any[] = [];
    scope.row["所属机构"].map((item: any) => {
      arr.push(item["医院名称"]);
    });
    return arr.join(",");
  }
  /**
   * @description 编辑
   */
  private composeThis(hospital) {
    this.targetHospital = hospital;
    this.detailType = "compose";
    this.ifShowHospitalDetail = true;
  }
  /**
   * @description 删除
   */
  private deleteThis(hospital) {
    this.$confirm("确定要删除吗？").then((data: any) => {
      console.log(data);
      const params: any = {
        data: {
          hospital_id: hospital.hospital_id
        }
      };
      DeleteHospital(this, params).then(() => {
        this.$message.success("删除成功");
        this.detailType = "add";
        this.refresh();
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getHospitals();
  }
}
